export enum ERateChangeType {    
    Percent,
    Numeric
}